import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home.js";
import Header from "../Component/Header.js";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../LetterDigiCom/letterDigiCom-styles.css";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService.js";
import {
  policyLoanEnquiry,
  policyLoanHistory,
} from "./RequestStatusService/requestStatusService.js";
import Skeleton from "react-loading-skeleton";
import "moment/locale/th";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, Col, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CurrencyFormater } from "../../util/index.js";
import styles from "./requestStatus-styles.module.css";
import { CurrencyFormaterRound } from "../../util/function.js";
import { Typography, Paper, Stack, Box, Grid } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { BiDetail } from "react-icons/bi";
import { getRequestStatusDetail } from "../RequestStatus/RequestStatusService/requestStatusService.js";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";

const RequestStatusDetail = () => {
  const location = useLocation();
  const [requestDate, subject, status, requestDateTime] = location.state
    ? [
        location.state.requestDate,
        location.state.subject,
        location.state.status,
        location.state.requestDateTime,
      ]
    : [null, null, null, null];

  console.log("requestDate:", requestDate);
  console.log("subject:", subject);
  console.log("status:", status);
  console.log("requestDateTime:", requestDateTime);

  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const [cusTel, setCusTel] = useState("");
  // const policyNo = searchParams.get("policyNo") || "";
  let navigate = useNavigate();
  const [customerId, setCustomerId] = useState(
    localStorage.getItem("customer_id")
  );
  const [rowDReqStatusDetail, setRowDReqStatusDetail] = useState([]);
  const [subjectDis, setSubjectDis] = useState([]);
  const [dateDis, setDateDis] = useState([]);
  const [statusDis, setStatusDis] = useState([]);
  const [policyNoDis, setPolicyNoDis] = useState([]);
  const formattedDate = ((s) => {
    const [y, m, d, h, mi] = s.replace(" ", "-").replace(":", "-").split("-");
    const date = new Date(`${+y - 543}-${m}-${d}T${h}:${mi}}`);
    return `${d}/${m}/${y} ${h}:${mi}`;
  })(requestDateTime);

  useEffect(() => {
    if (!location.state) {
      navigate("/RequestStatus"); // หรือ redirect กลับ
    }
  }, []);

  const goBack = () => {
    navigate("/RequestStatus");
  };

  const statusColor = "#ff5c47";

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const fetchDataReqStatusDetail = async () => {
    setLoadingContent(true);

    const result = await getRequestStatusDetail(
      decryptCardNumber(customerId, process.env.REACT_APP_ENCRYPT_DATA),
      subject,
      status,
      requestDate
    );

    setTimeout(() => {
      setRowDReqStatusDetail(result.data);
      console.log(result.data);
      setSubjectDis(result.data.subject);
      setStatusDis(result.data.status);
      setDateDis(result.data.requestDate);
      setLoadingContent(false);
    }, 1000);
  };

  useEffect(() => {
    fetchDataReqStatusDetail();
    console.log(requestDateTime);
  }, []);

  const getStatusLabel = (status) => {
    switch (status) {
      case "New":
        return "รอดำเนินการ";
      case "Taken":
        return "กำลังดำเนินการ";
      case "Closed":
        return "ดำเนินการเรียบร้อย";
      case "Canceled":
        return "ยกเลิก";
      default:
        return "-";
    }
  };

  const statusMap = {
    New: {
      icon: "🟠", // รอดำเนินการ
      label: "รอดำเนินการ",
    },
    Taken: {
      icon: "⏳", // กำลังดำเนินการ
      label: "กำลังดำเนินการ",
    },
    Closed: {
      icon: "✅", // ดำเนินการเรียบร้อย
      label: "ดำเนินการเรียบร้อย",
    },
    Canceled: {
      icon: "❌", // ยกเลิก
      label: "ยกเลิก",
    },
  };

  const renderStatus = (status) => {
    const statusItem = statusMap[status];
    if (!statusItem) return "-";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {/* <span style={{ fontSize: "18px" }}>{statusItem.icon}</span> */}
        <span>{statusItem.label}</span>
      </div>
    );
  };

  const renderStatusDetail = (status) => {
    const statusItem = statusMap[status];
    if (!statusItem) return "-";

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span style={{ fontSize: "18px" }}>{statusItem.icon}</span>
        <span>{statusItem.label}</span>
      </div>
    );
  };

  const formatParts = (s) => {
    if (!s) return { dateText: "-", timeText: "-" };
    const [y, m, d, h, mi, ss] = s
      .replace(" ", "-")
      .replaceAll(":", "-")
      .split("-");

    // ถ้าข้อมูลเป็น พ.ศ. ให้ลบ 543 ถ้าเป็น ค.ศ. อยู่แล้วจะไม่ต้องลบ
    const year = +y > 2400 ? +y - 543 : +y;

    return {
      dateText: `${d}/${m}/${y}`, // แสดงตามที่ต้องการ (ถ้าต้องการแสดง พ.ศ. ใช้ y แทน year)
      timeText: ss ? `${h}:${mi}:${ss}` : `${h}:${mi}`,
    };
  };

  const { dateText, timeText } = formatParts(requestDateTime);
  const labelFont = {
    fontWeight: "bold",
    fontSize: {
      xs: "0.95rem",
      sm: "1rem",
      md: "1.05rem",
      lg: "1.15rem",
      xl: "1.25rem",
    },
  };
  const valueFont = {
    fontSize: {
      xs: "0.95rem",
      sm: "1rem",
      md: "1.05rem",
      lg: "1.15rem",
      xl: "1.25rem",
    },
  };

  return (
    <div>
      <Header_Home />
      <Header title="รายละเอียดสถานะคำร้อง" />
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}

      <div className="frame-loan">
        <div className="containers">
          {LoadingContent && (
            <>
              <Row className="card-custom3 d-flex">
                <Col className="mt-3">
                  <Skeleton style={{ height: "30px" }} />
                  <div className="d-flex flex-row justify-content-between">
                    <Skeleton />
                  </div>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </Col>
              </Row>
              <br />
            </>
          )}
          {!LoadingContent && (
            <Box>
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 3,
                  p: 2,
                  mb: 2,
                  position: "relative",
                  overflow: "hidden", // 👈 กันเส้นยื่นออกนอกกรอบ
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                  <BiDetail
                    color="#555"
                    style={{
                      // responsive icon size
                      width: "1.2rem", // fallback
                      height: "1.2rem",
                      fontSize: "1.2rem",
                    }}
                    className="responsive-icon"
                  />

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      fontFamily: "Prompt-Thin",
                      // responsive font size
                      fontSize: {
                        xs: "0.9rem", // จอเล็ก
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem", // จอใหญ่
                      },
                    }}
                  >
                    รายละเอียดคำร้อง : {subject}
                  </Typography>
                </Stack>

                {/* วันที่/เวลา: เวลาอยู่ใต้วันที่บนจอเล็ก */}
                {/* วันที่/เวลา: xs,sm = แยกบรรทัดและเยื้อง; md+ = ต่อท้ายใกล้กัน */}
                <Box
                  className="font-new"
                  sx={{
                    mb: 1,
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "max-content 1fr", // label | value
                      sm: "max-content 1fr",
                      md: "max-content auto", // md+: label | (date+time)
                    },
                    columnGap: 1,
                    alignItems: "baseline",
                  }}
                >
                  {/* แถว 1: Label */}
                  <Typography
                    component="div"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem",
                      },
                    }}
                  >
                    <strong>วันที่ทำรายการ :</strong>
                  </Typography>

                  {/* md+: แสดง date + time ติดกัน */}
                  <Box
                    sx={{
                      display: { xs: "none", sm: "none", md: "inline-flex" },
                      gap: 2,
                    }}
                  >
                    <Typography
                      component="span"
                      sx={{
                        fontSize: {
                          xs: "0.95rem",
                          sm: "1rem",
                          md: "1.05rem",
                          lg: "1.1rem",
                          xl: "1.1rem",
                        },
                      }}
                    >
                      {dateText}
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        fontSize: {
                          xs: "0.95rem",
                          sm: "1rem",
                          md: "1.05rem",
                          lg: "1.1rem",
                          xl: "1.1rem",
                        },
                      }}
                    >
                      {timeText}
                    </Typography>
                  </Box>

                  {/* xs/sm: date บรรทัดแรก */}
                  <Typography
                    component="div"
                    sx={{
                      display: { xs: "block", sm: "block", md: "none" },
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem",
                      },
                    }}
                  >
                    {dateText}
                  </Typography>

                  {/* xs/sm: ghost label เพื่อเยื้องเวลาให้ตรงกับวันที่ */}
                  <Typography
                    component="div"
                    sx={{
                      display: { xs: "block", sm: "block", md: "none" },
                      visibility: "hidden",
                      fontWeight: "bold",
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem",
                      },
                    }}
                  >
                    วันที่ทำรายการ :
                  </Typography>

                  {/* xs/sm: เวลา บรรทัดถัดไป */}
                  <Typography
                    component="div"
                    sx={{
                      display: { xs: "block", sm: "block", md: "none" },
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem",
                      },
                    }}
                  >
                    {timeText}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  className="font-new"
                  sx={{
                    gap: { xs: 0.5, sm: 0.75, md: 1 }, // ระยะห่างระหว่าง label กับค่า
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.1rem",
                        xl: "1.1rem",
                      },
                    }}
                  >
                    สถานะคำร้อง :
                  </Typography>

                  <Box
                    sx={{
                      // ให้ข้อความข้างในจาก renderStatus สืบทอดขนาดนี้ไป
                      fontSize: {
                        xs: "0.95rem",
                        sm: "1rem",
                        md: "1.05rem",
                        lg: "1.15rem",
                        xl: "1.25rem",
                      },
                      lineHeight: 1.6,
                    }}
                  >
                    {renderStatus(status)}
                  </Box>
                </Box>
              </Paper>

              {/* รายการผลลัพธ์ */}
              {rowDReqStatusDetail.map((item, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 3,
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                    <BiDetail size={22} color="#888" />
                    <Typography
                      className="font-new"
                      variant="subtitle1"
                      sx={{ fontWeight: "bold" }}
                    >
                      กรมธรรม์ : {item.policyNo}
                    </Typography>
                  </Stack>
                  <Typography
                    className="font-new"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <strong>ผลลัพธ์</strong>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 8,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: 10,
                          height: 10,
                          // backgroundColor: statusColor,
                          borderRadius: "50%",
                          marginRight: 4,
                        }}
                      ></span>
                      {renderStatusDetail(item.status)}
                    </span>
                  </Typography>
                </Paper>
              ))}
            </Box>
          )}
          <Row className="d-flex flex-column mt-2 mb-5">
            <Col className="d-flex justify-content-start px-5">
              <button
                onClick={goBack}
                className="btn-coupon-back w-sm-100 w-lg-25 p-2 bold text-black"
              >
                ย้อนกลับ
              </button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RequestStatusDetail;
